import React from 'react';
export function HierarchyDiagram() {
  return <div className="relative w-full aspect-square max-w-md mx-auto flex items-center justify-center p-8" data-id="element-170">
      {/* Background decorative rings */}
      <div className="absolute inset-0 border border-muted-foreground/10 rounded-full scale-100 animate-[spin_60s_linear_infinite]" data-id="element-171" />
      <div className="absolute inset-0 border border-muted-foreground/10 rounded-full scale-75 animate-[spin_45s_linear_infinite_reverse]" data-id="element-172" />
      <div className="absolute inset-0 border border-muted-foreground/10 rounded-full scale-50 animate-[spin_30s_linear_infinite]" data-id="element-173" />

      {/* Central Structure */}
      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center" data-id="element-174">
        {/* Organism (Outer Container) */}
        <div className="absolute inset-4 border-2 border-pink-200 bg-pink-50/30 rounded-full flex items-center justify-center animate-pulse" data-id="element-175">
          {/* Organ (Triangle Layout) */}
          <div className="relative w-3/4 h-3/4" data-id="element-176">
            {/* Cell 1 (Top) */}
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-24 h-24 bg-indigo-100/80 rounded-full border border-indigo-300 flex items-center justify-center shadow-sm" data-id="element-177">
              <div className="grid grid-cols-2 gap-1 p-2" data-id="element-178">
                <div className="w-3 h-3 bg-cyan-500 rounded-full" data-id="element-179" />
                <div className="w-3 h-3 bg-cyan-500 rounded-full" data-id="element-180" />
                <div className="w-3 h-3 bg-blue-500 rounded-full col-span-2 mx-auto" data-id="element-181" />
              </div>
            </div>

            {/* Cell 2 (Bottom Left) */}
            <div className="absolute bottom-4 left-0 w-24 h-24 bg-indigo-100/80 rounded-full border border-indigo-300 flex items-center justify-center shadow-sm" data-id="element-182">
              <div className="grid grid-cols-2 gap-1 p-2" data-id="element-183">
                <div className="w-3 h-3 bg-cyan-500 rounded-full" data-id="element-184" />
                <div className="w-3 h-3 bg-cyan-500 rounded-full" data-id="element-185" />
                <div className="w-3 h-3 bg-blue-500 rounded-full col-span-2 mx-auto" data-id="element-186" />
              </div>
            </div>

            {/* Cell 3 (Bottom Right) */}
            <div className="absolute bottom-4 right-0 w-24 h-24 bg-indigo-100/80 rounded-full border border-indigo-300 flex items-center justify-center shadow-sm" data-id="element-187">
              <div className="grid grid-cols-2 gap-1 p-2" data-id="element-188">
                <div className="w-3 h-3 bg-cyan-500 rounded-full" data-id="element-189" />
                <div className="w-3 h-3 bg-cyan-500 rounded-full" data-id="element-190" />
                <div className="w-3 h-3 bg-blue-500 rounded-full col-span-2 mx-auto" data-id="element-191" />
              </div>
            </div>

            {/* Connecting Lines */}
            <svg className="absolute inset-0 w-full h-full pointer-events-none opacity-30" data-id="element-192">
              <line x1="50%" y1="20%" x2="20%" y2="70%" stroke="currentColor" strokeWidth="2" className="text-purple-400" data-id="element-193" />
              <line x1="50%" y1="20%" x2="80%" y2="70%" stroke="currentColor" strokeWidth="2" className="text-purple-400" data-id="element-194" />
              <line x1="20%" y1="70%" x2="80%" y2="70%" stroke="currentColor" strokeWidth="2" className="text-purple-400" data-id="element-195" />
            </svg>
          </div>
        </div>
      </div>

      {/* Legend/Labels (Floating) */}
      <div className="absolute top-0 right-0 bg-white/90 backdrop-blur-sm p-3 rounded-lg shadow-sm border text-xs space-y-1" data-id="element-196">
        <div className="flex items-center gap-2" data-id="element-197">
          <div className="w-2 h-2 rounded-full bg-cyan-500" data-id="element-198"></div> Atom
        </div>
        <div className="flex items-center gap-2" data-id="element-199">
          <div className="w-2 h-2 rounded-full bg-blue-500" data-id="element-200"></div> Molecule
        </div>
        <div className="flex items-center gap-2" data-id="element-201">
          <div className="w-2 h-2 rounded-full bg-indigo-500" data-id="element-202"></div> Cell
        </div>
        <div className="flex items-center gap-2" data-id="element-203">
          <div className="w-2 h-2 rounded-full bg-purple-500" data-id="element-204"></div> Organ
        </div>
        <div className="flex items-center gap-2" data-id="element-205">
          <div className="w-2 h-2 rounded-full bg-pink-500" data-id="element-206"></div> Organism
        </div>
      </div>
    </div>;
}